import { createAction } from 'redux-actions';
import { fetchFromOmnibusClient } from '../clients/fetchFromOmnibusClient';
import { FETCH_FROM_OMNI_BUS } from '../constants/asyncActionTypes';
import { buildRequestErrorMetaObject } from 'conversations-error-reporting/error-actions/builders/buildRequestErrorMetaObject';
import { silenceErrorAlert } from 'conversations-error-reporting/error-actions/builders/silenceErrorAlert';
import { omnibusFulfilled, parseOmnibus } from 'find-and-filter-data/omnibus/public';
import { getCurrentViewId } from '../operators/omnibusGetters';
const fetchFromOmnibusStart = createAction(FETCH_FROM_OMNI_BUS.STARTED);
const fetchFromOmnibusSucceed = createAction(FETCH_FROM_OMNI_BUS.SUCCEEDED);
const fetchFromOmnibusFailed = createAction(FETCH_FROM_OMNI_BUS.FAILED, undefined, ({
  error,
  requestArgs
}) => requestArgs.silent ? silenceErrorAlert({
  error
}) : buildRequestErrorMetaObject({
  error
}));
export const fetchFromOmnibus = requestArgs => dispatch => {
  dispatch(fetchFromOmnibusStart({
    requestArgs
  }));
  return fetchFromOmnibusClient(requestArgs).then(omnibus => {
    const [findAndFilterOmnibus, remainingOmnibus] = parseOmnibus(omnibus);
    const viewId = getCurrentViewId(omnibus);
    if (viewId) {
      dispatch(omnibusFulfilled(findAndFilterOmnibus, viewId, requestArgs.inboxId));
    }
    return dispatch(fetchFromOmnibusSucceed({
      data: remainingOmnibus,
      requestArgs
    }));
  }).catch(error => dispatch(fetchFromOmnibusFailed({
    requestArgs,
    error
  })));
};